// extracted by mini-css-extract-plugin
export default {"card":"Feed_card__3jnNf","card__text":"Feed_card__text__H9cxz"};